"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var actions_1 = require("./actions");

var ReactSimpleSoundCloudWidget =
/** @class */
function (_super) {
  __extends(ReactSimpleSoundCloudWidget, _super);

  function ReactSimpleSoundCloudWidget(props) {
    var _this = _super.call(this, props) || this;

    _this.internalWidget = null;
    _this.id = "react-sc-widget" + Math.random().toString(36).substr(2, 6);
    return _this;
  }

  ReactSimpleSoundCloudWidget.prototype.componentDidMount = function () {
    var _this = this;

    console.log('this.id', this.id);
    actions_1.createWidget(this.id, function (widget) {
      console.log('widget made... setting up', widget);

      _this.setupWidget(widget);

      _this.reloadWidget();
    });
  };

  ReactSimpleSoundCloudWidget.prototype.shouldComponentUpdate = function (nextProps) {
    return nextProps.url !== this.props.url;
  };

  ReactSimpleSoundCloudWidget.prototype.componentDidUpdate = function () {
    this.reloadWidget();
  };

  ReactSimpleSoundCloudWidget.prototype.componentWillUnmount = function () {
    var win = window;
    if (!this.internalWidget) return;
    this.internalWidget.unbind(win.SC.Widget.Events.PLAY);
    this.internalWidget.unbind(win.SC.Widget.Events.PAUSE);
    this.internalWidget.unbind(win.SC.Widget.Events.FINISH);
    this.internalWidget.unbind(win.SC.Widget.Events.READY);
  };

  ReactSimpleSoundCloudWidget.prototype.setupWidget = function (widget) {
    var win = window;
    this.internalWidget = widget;
    this.internalWidget.bind(win.SC.Widget.Events.PLAY, this.props.onPlay);
    this.internalWidget.bind(win.SC.Widget.Events.PAUSE, this.props.onPause);
    this.internalWidget.bind(win.SC.Widget.Events.FINISH, this.props.onEnd);
    this.internalWidget.bind(win.SC.Widget.Events.READY, this.props.onReady);
  };

  ReactSimpleSoundCloudWidget.prototype.reloadWidget = function () {
    if (!this.internalWidget) return;
    this.internalWidget.load(this.props.url, __assign({}, this.props.config));
  };

  ReactSimpleSoundCloudWidget.prototype.render = function () {
    console.log('rendering react-simple-soundcloud-widget', this.props.url);
    var _a = this.props,
        config = _a.config,
        url = _a.url;
    return React.createElement("iframe", {
      id: this.id,
      width: "100%",
      height: config && config.visual ? '450' : '166',
      scrolling: "no",
      frameBorder: "no",
      src: "https://w.soundcloud.com/player/?url=" + url
    });
  };

  return ReactSimpleSoundCloudWidget;
}(React.Component);

ReactSimpleSoundCloudWidget.defaultProps = {
  config: {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onEnd: function onEnd() {}
};
exports["default"] = ReactSimpleSoundCloudWidget;